import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import * as i3 from '@angular/forms';
import { Validators, FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import * as i1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails } from 'visa-store';
import { Subject } from 'rxjs';
import * as i2 from 'app-services-library';
import * as i4 from '@angular/common';
import * as i5 from 'primeng/calendar';
import { PrimengLibraryModule } from 'primeng-library';

class CustomDateTimePickerService {
    constructor() { }
}
CustomDateTimePickerService.ɵfac = function CustomDateTimePickerService_Factory(t) { return new (t || CustomDateTimePickerService)(); };
CustomDateTimePickerService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomDateTimePickerService, factory: CustomDateTimePickerService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomDateTimePickerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function CustomDateTimePickerComponent_em_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 10);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function CustomDateTimePickerComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
function CustomDateTimePickerComponent_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "width": a0 }; };
class CustomDateTimePickerComponent {
    constructor(store, appServicesLibraryService) {
        this.store = store;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.currentDate = new Date();
    }
    ngOnInit() {
        var _a, _b;
        this.userType = sessionStorage.getItem('userTypeRole');
        // this.inputParams.value = 'Mon Jul 28 2023 23:18:36 GMT+0530 (India Standard Time)';
        let dateFieldVal = null;
        let timeFieldVal = null;
        let dateStr = null;
        let timeStr = null;
        if ((_a = this.inputParams.value) === null || _a === void 0 ? void 0 : _a.dateFieldVal) {
            dateFieldVal = new Date(this.inputParams.value.dateFieldVal);
            dateStr = this.getDateStr(this.inputParams.value.dateFieldVal);
        }
        if ((_b = this.inputParams.value) === null || _b === void 0 ? void 0 : _b.timeFieldVal) {
            timeFieldVal = new Date(this.inputParams.value.timeFieldVal);
            timeStr = this.getTimeStr(this.inputParams.value.timeFieldVal);
        }
        const dateTimeValidators = this.inputParams.mandatory ? [Validators.required] : [];
        this.group.addControl(this.inputParams.name, new FormGroup({
            dateFieldVal: new FormControl(dateFieldVal, dateTimeValidators),
            timeFieldVal: new FormControl(timeFieldVal, dateTimeValidators),
            dateFieldStringVal: new FormControl(dateStr),
            timeFieldStringVal: new FormControl(timeStr)
        }));
        if (this.inputData) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a;
                this.inputData.stepStatusCode = (_a = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                this.toggleInputFields();
            });
        }
        this.setMinTime();
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    setMinTime() {
        const now = new Date();
        this.minTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes());
    }
    toggleInputFields() {
        if (((this.userType === 'Petitioner' || this.userType === 'Attorney') && (this.inputData.stepStatusCode === 'COMPLETE' || this.inputData.stepStatusCode === 'NEW')) || (this.userType === 'Beneficiary' && (this.inputData.stepStatusCode === 'COMPLETE' || this.inputData.stepStatusCode === 'SUBMIT' || this.inputData.stepStatusCode === 'NEW'))) {
            this.group.disable();
        }
        else {
            this.group.enable();
        }
    }
    getDateStr(event) {
        const dateObj = new Date(event);
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    dateChange(event) {
        this.group.controls[this.inputParams.name].patchValue({
            dateFieldStringVal: this.getDateStr(event)
        });
        if (this.group.controls[this.inputParams.name].value.timeFieldVal) {
            this.group.controls[this.inputParams.name].value.dateFieldVal.setHours(this.group.controls[this.inputParams.name].value.timeFieldVal.getHours());
            this.group.controls[this.inputParams.name].value.dateFieldVal.setMinutes(this.group.controls[this.inputParams.name].value.timeFieldVal.getMinutes());
            this.group.controls[this.inputParams.name].value.dateFieldVal.setSeconds(this.group.controls[this.inputParams.name].value.timeFieldVal.getSeconds());
            // this.inputParams.value = this.group.controls[this.inputParams.name].value.dateFieldVal;
        }
        else {
            // this.inputParams.value = event;
            this.group.controls[this.inputParams.name].patchValue({
                dateFieldVal: event
            });
        }
    }
    getTimeStr(event) {
        const dateObj = new Date(event);
        let hours = dateObj.getHours();
        const minutes = dateObj.getMinutes().toString().padStart(2, '0');
        const amPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        const hoursStr = hours.toString().padStart(2, '0');
        return `${hoursStr}:${minutes} ${amPm}`;
    }
    onSelect(date, event) {
        if (event) {
            const dateObj = new Date(event);
            let hour = dateObj.getHours();
            let min = dateObj.getMinutes();
            let seconds = dateObj.getSeconds();
            date.setHours(hour);
            date.setMinutes(min);
            // date.setSeconds(seconds);
            date.setSeconds(0);
            // this.inputParams.value = date;
            this.group.controls[this.inputParams.name].patchValue({
                dateFieldVal: date,
                timeFieldVal: date,
                timeFieldStringVal: this.getTimeStr(event)
            });
        }
    }
}
CustomDateTimePickerComponent.ɵfac = function CustomDateTimePickerComponent_Factory(t) { return new (t || CustomDateTimePickerComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.AppServicesLibraryService)); };
CustomDateTimePickerComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomDateTimePickerComponent, selectors: [["lib-custom-date-time-picker"]], inputs: { formControlName: "formControlName", value: "value", inputParams: "inputParams", inputData: "inputData", group: "group" }, decls: 14, vars: 17, consts: [[1, "form-group", 3, "formGroup"], [1, "label-cls", "w-100"], [1, "common-bene-class-for-translation"], ["class", "error", 4, "ngIf"], [1, "row", 3, "formGroupName"], [1, "col-7", "mb-2", "p-0"], ["id", "dateDiv", "yearRange", "1900:2100", "appendTo", "body", "styleClass", "p-form-datepicker", "yearNavigator", "true", "monthNavigator", "true", "inputId", "icon", "formControlName", "dateFieldVal", "placeholder", "MM/DD/YYYY", 1, "im-input-calendar", "mw-100", 3, "minDate", "showIcon", "onSelect"], ["dateTime", ""], [1, "col-5", "mb-2", "pr-0"], ["id", "timeDiv", "timeOnly", "true", "showTime", "true", "hourFormat", "12", "appendTo", "body", "formControlName", "timeFieldVal", "placeholder", "HH:MM", 3, "showIcon", "hideOnDateTimeSelect", "minDate", "icon", "disabled", "onSelect"], [1, "error"]], template: function CustomDateTimePickerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, CustomDateTimePickerComponent_em_4_Template, 2, 0, "em", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "p-calendar", 6, 7);
        i0.ɵɵlistener("onSelect", function CustomDateTimePickerComponent_Template_p_calendar_onSelect_7_listener($event) { return ctx.dateChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, CustomDateTimePickerComponent_span_9_Template, 2, 0, "span", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵelementStart(11, "p-calendar", 9);
        i0.ɵɵlistener("onSelect", function CustomDateTimePickerComponent_Template_p_calendar_onSelect_11_listener($event) { return ctx.onSelect(ctx.group.controls[ctx.inputParams.name].value.dateFieldVal, $event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(12, "br");
        i0.ɵɵtemplate(13, CustomDateTimePickerComponent_span_13_Template, 2, 0, "span", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(15, _c0, ctx.inputParams == null ? null : ctx.inputParams.style == null ? null : ctx.inputParams.style.width));
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.inputParams == null ? null : ctx.inputParams.label);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.mandatory);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroupName", ctx.formControlName);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("minDate", (ctx.inputParams == null ? null : ctx.inputParams.showTodayByDefault) ? ctx.currentDate : null)("showIcon", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.mandatory) && ctx.group.get(ctx.inputParams.name).touched && ctx.group.get(ctx.inputParams.name).get("dateFieldVal").value === "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("showIcon", true)("hideOnDateTimeSelect", true)("minDate", (ctx.inputParams == null ? null : ctx.inputParams.disablePastTime) ? ctx.minTime : null)("icon", "pi pi-clock")("disabled", !ctx.group.controls[ctx.inputParams.name].value.dateFieldVal);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.mandatory) && ctx.group.get(ctx.inputParams.name).touched && ctx.group.get(ctx.inputParams.name).get("timeFieldVal").value === "");
    } }, directives: [i3.NgControlStatusGroup, i3.FormGroupDirective, i4.NgIf, i3.FormGroupName, i5.Calendar, i3.NgControlStatus, i3.FormControlName], styles: [".customDateTime[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.error[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomDateTimePickerComponent, [{
        type: Component,
        args: [{
                selector: 'lib-custom-date-time-picker',
                templateUrl: 'custom-date-time-picker.component.html',
                styleUrls: ['custom-date-time-picker.component.scss'
                ]
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.AppServicesLibraryService }]; }, { formControlName: [{
            type: Input
        }], value: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], inputData: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class CustomDateTimePickerModule {
}
CustomDateTimePickerModule.ɵfac = function CustomDateTimePickerModule_Factory(t) { return new (t || CustomDateTimePickerModule)(); };
CustomDateTimePickerModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomDateTimePickerModule });
CustomDateTimePickerModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            ReactiveFormsModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomDateTimePickerModule, { declarations: [CustomDateTimePickerComponent], imports: [ReactiveFormsModule,
        PrimengLibraryModule], exports: [CustomDateTimePickerComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomDateTimePickerModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomDateTimePickerComponent],
                imports: [
                    ReactiveFormsModule,
                    PrimengLibraryModule
                ],
                exports: [CustomDateTimePickerComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-date-time-picker
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomDateTimePickerComponent, CustomDateTimePickerModule, CustomDateTimePickerService };
//# sourceMappingURL=custom-date-time-picker.js.map
